import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { EventService } from '../../core/services/event.service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { LAYOUT_MODE } from '../layouts.model';
import { ErrorMessageService } from 'src/app/service/errorMessageService';
import { Observable } from 'rxjs';
import { array } from '@amcharts/amcharts5';
import { ValidationMessage } from 'src/app/model/DataTextVal';
import { CompanyInfo } from 'src/app/model/setting/Company';
import { AccountService } from 'src/app/service/accountservice';
import NepaliDate from 'nepali-date-converter';
import { SingletonService } from 'src/app/service/SingltonService';
import { select, Store } from '@ngrx/store';
import { clearDBInitial, logoutClearState } from 'src/app/store/buid.actions';
import Swal from 'sweetalert2';
import { AppState } from 'src/app/store/buid.reducer';
import { AppExtension } from 'src/app/apphelper/AppExtension';
import { DateRangeHelper } from 'src/app/apphelper/DateRangeHelper';
import { DashboardService } from 'src/app/service/dashboardService';
import { LocalStorageService } from 'src/app/service/LocalStorageService';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: false
})

/**
 * Topbar Component
 */
export class TopbarComponent implements OnInit {
  mode: string | undefined;
  element: any;
  flagvalue: any;
  cookieValue: any;
  countryName: any;
  valueset: any;
  userId: any;
  companies: any;
  numero: Observable<ValidationMessage[]>;
  errors: ValidationMessage[];
  BUID: string;
  organizationId: string;
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    public _cookiesService: CookieService,
    public translate: TranslateService,
    private eventService: EventService,
    private numeroService: ErrorMessageService,
    private accountService: AccountService,
    private singletonService: SingletonService,
    private store: Store<AppState>,
    private dashboardService: DashboardService,
    private localStorageService:LocalStorageService
  ) {
    this.store.pipe(select(state => state.buidState)).subscribe(buid => {
      this.userId = buid.userId;
      this.organizationId = buid.organizationId;
      this.fyStartDate = buid.startDate;
      this.fyEndDate = buid.endDate;
    });
    this.companies = new CompanyInfo()
    this.errors = new Array();
    this.numero = this.numeroService.numero;
    this.numero.subscribe((data) => {
      this.errors = data;
    });

  }

  /**
   * Language Listing
   */
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  layoutMode: string;

  // ── Date Range ──
  dateRangeTypeId: string = 'TODAY';
  dateFilters = [
    { dataTextField: 'Today', dataValueField: 'TODAY' },
    { dataTextField: 'Yesterday', dataValueField: 'YESTERDAY' },
    { dataTextField: 'Weekly', dataValueField: 'WEAKLY' },
    { dataTextField: 'Fort Nightly', dataValueField: 'FORT_NIGHTALY' },
    { dataTextField: 'Current Month', dataValueField: 'CURRENT_MONTH' },
    { dataTextField: 'Last Month', dataValueField: 'LAST_MONTH' },
    { dataTextField: 'Quarterly', dataValueField: 'LAST_3_MONTHS' },
    { dataTextField: 'Half Yearly', dataValueField: 'LAST_6_MONTHS' },
    { dataTextField: 'Fiscal Year', dataValueField: 'FISCAL_YEAR' },
  ];
  fyStartDate: string;
  fyEndDate: string;
  // ── Search ──
  searchParam: string = '';
  searchResults: any[] = [];
  showSearchDropdown: boolean = false;
  isSearching: boolean = false;
  private searchDebounceTimer: any;

  private toLocalDateString(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  onddlDateRangeChange(filter: string): void {
    const appSettingRaw = localStorage.getItem('AS');
    const appSetting = appSettingRaw ? JSON.parse(appSettingRaw) : {};
    const source = (!appSetting.dateType || appSetting.dateType.length === 0) ? 'BS' : appSetting.dateType;

    let startDate: string;
    let endDate: string;

    if (filter === 'FISCAL_YEAR') {
      // fyStartDate/fyEndDate already stored — reformat them too
      startDate = this.toLocalDateString(new Date(this.fyStartDate));
      endDate = this.toLocalDateString(new Date(this.fyEndDate));
    } else if (source === 'AD') {
      const date = DateRangeHelper.getDateRange(filter);
      startDate = this.toLocalDateString(date.fromDate);
      endDate = this.toLocalDateString(date.toDate);
    } else {
      const date = DateRangeHelper.getDateRangeNP(filter);
      startDate = this.toLocalDateString(date.fromDate);
      endDate = this.toLocalDateString(date.toDate);
    }

    localStorage.setItem('SD', startDate);
    localStorage.setItem('ED', endDate);
    localStorage.setItem('DATE_RANGE_TYPE', filter);

    this.dashboardService.emitDateRange(filter, startDate, endDate);
  }

  ngOnInit(): void {

    const companyName = this.getCompanyName();
    const userName = this.getUserName();
    const branchName = this.getBranchName();
    const startDate = this.getCompanyStartDate();
    const endDate = this.getCompanyEndDate();
    const startNEDate = this.getCompanyNEStartDate()
    const endNEDate = this.getCompanyNEEndDate()
    this.layoutMode = LAYOUT_MODE;
    this.element = document.documentElement;
    // Cookies wise Language set
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = 'assets/images/flags/us.jpg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
  }



  /**
   * Language Value Set
   */
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Topbar Light-Dark Mode Change
   */
  changeMode(mode: string) {
    this.layoutMode = mode;
    localStorage.setItem('changeMode', this.layoutMode)
    this.mode = localStorage.getItem('changeMode') || 'light';
    this.eventService.broadcast('changeMode', this.mode);
    window.location.reload()


  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this.singletonService.SetParentMenu(null);
    this.router.navigate(['/account/login']);
    //localStorage.clear();
     // localStorage.clear();
this.localStorageService.clearData();
    this.accountService.logoutOfOtherDevices(this.userId, this.organizationId).subscribe(
      (res) => {
        Swal.fire({
          title: 'Success',
          text: 'Logged Out  successfully!',
          icon: 'success'
        }).then(() => {
          this.router.navigateByUrl('/');
        });
      },
      (err) => {
        Swal.fire('Error', 'Failed to loggout devices: ' + err.message, 'error');
      }
    );


    this.store.dispatch(logoutClearState());
  }
  // changeCompany() {
  //   // localStorage.removeItem('AS');
  //   // localStorage.removeItem('CN');
  //   // localStorage.removeItem('CUID');
  //   // localStorage.removeItem('BUID');
  //   // localStorage.removeItem('BN');
  //   // localStorage.removeItem('PM');
  // }
  getCompanyName() {
    const companyName = localStorage.getItem('CN');

    if (companyName) {
      return companyName;
    } else {
      return ''; // Return a default value if companyName is not found
    }
  }
  getBranchName() {
    const branchName = localStorage.getItem('BN');
    if (branchName) {
      return branchName;
    } else {
      return '';
    }
  }
  getUserName() {
    const loginData = localStorage.getItem('login'); // Get the login data from localStorage
    if (loginData) {
      try {
        const parsedData = JSON.parse(loginData); // Parse the JSON string

        if (parsedData.data && parsedData.data.length > 0) {
          this.userId = parsedData.data[0].userId
          return parsedData.data[0].emailId; // Get the emailId from the first user in the data array
          // Optionally log the emailId
        } else {
          console.log('No user data found in login information.');
        }
      } catch (error) {
        console.error('Error parsing login data:', error);
      }
    } else {
      console.log('No login data found in localStorage.');
    }
  }

  getCompanyStartDate() {
    const startDate = localStorage.getItem('SD')
    if (startDate) {
      return startDate
    }
    else {
      return '';
    }
  }

  getCompanyEndDate() {
    const startDate = localStorage.getItem('ED')
    if (startDate) {
      return startDate
    }
    else {
      return '';
    }
  }
  getStorageName() {
    const name = localStorage.getItem('DBInitial')
    if (name) {
      return name
    }
    else {
      return '';
    }
  }


  getCompanyNEStartDate() {
    const startDate = localStorage.getItem('NESD')
    if (startDate) {

      return startDate
    }
    else {
      return '';
    }
  }

  getCompanyNEEndDate() {
    const endDate = localStorage.getItem('NEED')
    if (endDate) {

      return endDate
    }
    else {
      return '';
    }
  }
  onLogoClick(event: MouseEvent): void {
    event.preventDefault();

    const loginData = localStorage.getItem('login');
    const companyname = localStorage.getItem('CN');
    const companyBranch = localStorage.getItem('BN');

    if (loginData) {
      const parsedData = JSON.parse(loginData);

      if (parsedData && parsedData.data && parsedData.data.length > 0) {
        if (companyname) {
          if (companyBranch) {
            this.router.navigate(['/home/dashboard']);
          } else {
            // this.router.navigate(['/home/company']);
            this.router.navigate(['/home/dashboard']);
          }
        } else {
          this.router.navigate(['/home/company']);
        }
      } else {
        this.router.navigate(['/']);
      }
    } else {
      this.router.navigate(['/']);
    }
  }

  setFocusOnErrorControl(index) {
    document.getElementById(this.errors[index].id).focus();
    document.getElementById(this.errors[index].id).scrollIntoView();
  }


  getlicenseDay() {
    const value = localStorage.getItem('licenseDay');
    return value ? Number(value) : 0;
  }

  // ── Search Methods ──
  onSearchInput(): void {
    clearTimeout(this.searchDebounceTimer);
    if (!this.searchParam || this.searchParam.trim().length < 2) {
      this.searchResults = [];
      this.showSearchDropdown = false;
      return;
    }
    this.searchDebounceTimer = setTimeout(() => {
      this.callSearchApi(this.searchParam.trim());
    }, 400);
  }

  triggerSearch(): void {
    if (!this.searchParam || this.searchParam.trim().length < 1) return;
    clearTimeout(this.searchDebounceTimer);
    this.callSearchApi(this.searchParam.trim());
  }

  onSearchSubmit(event: any): void {
    event.preventDefault();
    this.triggerSearch();
  }

  onSearchBlur(): void {
    setTimeout(() => {
      this.showSearchDropdown = false;
    }, 200);
  }

  private callSearchApi(param: string): void {
    this.isSearching = true;
    this.showSearchDropdown = true;
    const branchId = localStorage.getItem('BUID') || '0';

    this.dashboardService.searchInfoList(param, branchId).subscribe({
      next: (data) => {
        this.searchResults = data;
        this.isSearching = false;
      },
      error: (err) => {
        console.error('Search error:', err);
        this.searchResults = [];
        this.isSearching = false;
      }
    });
  }

  // onSearchResultClick(item: any): void {
  //   this.showSearchDropdown = false;
  //   this.searchParam = '';
  //   this.searchResults = [];

  //   if (item.url) {
  //     this.router.navigateByUrl(item.url);
  //   }
  // }

// onSearchResultClick(item: any): void {
//   this.showSearchDropdown = false;
//   this.searchParam = '';
//   this.searchResults = [];

//   if (item.url) {
//     this.router.navigateByUrl(item.url);
//   } else if (item.source === 'Account' || item.source === 'Stock') {
//     this.router.navigate(['/reports/search-details'], { state: { item } });
//   }
// }
onSearchResultClick(item: any): void {
  debugger
  this.showSearchDropdown = false;
  this.searchParam = '';
  this.searchResults = [];

  console.log('source:', item.source);
  console.log('url:', item.url);

  if (item.url) {
    this.router.navigateByUrl(item.url);
  } else if (item.source === 'Account' || item.source === 'Stock') {
    console.log('navigating to search-details');
    this.router.navigate(['/reports/search-details'], { state: { item } });
  }
}
get companyDateRangeTooltip(): string {
  const start = this.fyStartDate;
  const end = this.fyEndDate;
  if (!start || !end) return '';

  try {
    const startFmt = new Date(start).toLocaleDateString('en-GB'); // dd/MM/yyyy
    const endFmt = new Date(end).toLocaleDateString('en-GB');
    return `${startFmt} to ${endFmt}`;
  } catch {
    return `${start} to ${end}`; // fallback: raw values, never throws
  }
}
}
